import { render, staticRenderFns } from "./m-dot.vue?vue&type=template&id=0b6eeece&scoped=true&"
import script from "./m-dot.vue?vue&type=script&lang=js&"
export * from "./m-dot.vue?vue&type=script&lang=js&"
import style0 from "./m-dot.vue?vue&type=style&index=0&id=0b6eeece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6eeece",
  null
  
)

export default component.exports